module.exports = __webpack_public_path__ + "img/lpk_mobile.8808a059.png";